import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=49d996ac&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"
import style0 from "./Upload.vue?vue&type=style&index=0&id=49d996ac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d996ac",
  null
  
)

export default component.exports